import React, { useState } from "react";

import { GrInstagram } from "react-icons/gr";
import { FaXTwitter } from "react-icons/fa6";
import image from "../../assets/icon1.png";
import image2 from "../../assets/icon2.png";
import image3 from "../../assets/icon3.png";
import image4 from "../../assets/icon4.png";
import { FaLinkedinIn } from "react-icons/fa6";
import "./Footer.css";
import FaqItem from "./FaqItem";
import Logo from "../../assets/SVG/Logo-purple-white.svg";

const faqData = [
  {
    question: "About Us",
    answer: ["Our Company", "Newsroom", "Get In Touch"],
  },
  {
    question: "Services",
    answer: [
      "Adivsory and Computing",
      "Business Applications",
      "Cloud Servcies",
      "Data & Integration",
      "Managed Services",
    ],
  },
  {
    question: "Industries",
    answer: ["Our Company", "Newsroom", "Get In Touch"],
  },
];

const Footer = () => {
  const [selectedQuestion, setSelectedQuestion] = useState(null);
  // #cfede3

  return (
    <div className="bg-[#4f1951] dark:bg-dark dark:border-t-white dark:border-t-[1px] text-white w-full">
      <div className="w-[98%] hidden xl:w-[90%] mx-auto lg:flex flex-row gap-[50px] xl:gap-[150px] my-[100px]">
        <div className="flex flex-col gap-14 items-start ">
          <h1 className="text-xl md:text-3xl font-extrabold font-mono leading-normal">
            <span className="text-light">Gogi</span>
            <span className="text-[#15A5E7]">Bus</span>{" "}
          </h1>
          <div className="">
            <p className="text-[12px] font-light">Level 2, 10 Bond Street,</p>
            <p className="text-[12px] font-light">Sydney, NSW, 2000</p>
          </div>
          <div>
            <p className="text-[12px] font-light">+61 2 9657 0999</p>
            <p className="text-[12px] font-light">info@Gogibus.com</p>
          </div>
          <div className="flex flex-row self-center gap-4">
            <FaLinkedinIn
              className="hover:scale-90 cursor-pointer duration-300"
              size={40}
            />
          </div>
        </div>
        <div className="flex flex-col gap-10  w-[100%] justify-start">
          <div className="flex flex-row justify-between mt-5 items-start">
            <div className="flex  flex-col gap-4">
              <h1 className="font-bold">About Us</h1>
              <div className="flex flex-col gap-2">
                <p className="font-light text-[11px]">Our Company</p>
                <p className="font-light text-[11px]">Newsroom</p>
                <p className="font-light text-[11px]">Get in Touch</p>
              </div>
            </div>

            <div className="flex flex-col gap-4">
              <h1 className="font-bold">Services</h1>
              <div className="flex flex-col gap-2">
                <p className="font-light text-[11px]">Advisory & Consulting</p>
                <p className="font-light text-[11px]">Business Applications</p>
                <p className="font-light text-[11px]">Cloud Services</p>
                <p className="font-light text-[11px]">Data & Integration</p>
                <p className="font-light text-[11px]">Managed Services</p>
              </div>
            </div>

            <div className="flex flex-col gap-4">
              <h1 className="font-bold">Industries</h1>
              <div className="flex flex-col gap-2">
                <p className="font-light text-[11px]">Defence</p>
                <p className="font-light text-[11px]">
                  Federal and State Government
                </p>
                <p className="font-light text-[11px]">Financial Services</p>
                <p className="font-light text-[11px]">Education</p>
                <p className="font-light text-[11px]">Local Government</p>
                <p className="font-light text-[11px]">Manufacturing</p>
                <p className="font-light text-[11px]">Utilities</p>
              </div>
            </div>

            <div className="flex  flex-col gap-4">
              <h1 className="font-bold">Partners</h1>
            </div>

            <div className="flex  flex-col gap-4">
              <h1 className="font-bold">Insights</h1>
              <div className="flex flex-col gap-2">
                <p className="font-light text-[11px]">Our Perspectives</p>
                <p className="font-light text-[11px]">Featured Articles</p>
                <p className="font-light text-[11px]">Client Stories</p>
              </div>
            </div>

            <div className="flex  flex-col gap-4">
              <h1 className="font-bold">Carrers</h1>
              <div className="flex flex-col gap-2">
                <p className="font-light text-[11px]">Join our Team</p>
              </div>
            </div>

            <div className="flex  flex-col gap-4">
              <h1 className="font-bold">Investors</h1>
              <div className="flex flex-col gap-2">
                <p className="font-light text-[11px]">AGMs & Briefings</p>
                <p className="font-light text-[11px]">ASX Announcements</p>
                <p className="font-light text-[11px]">Board of Directors</p>
                <p className="font-light text-[11px]">Corporate Governance</p>
                <p className="font-light text-[11px]">My Shareholding</p>
                <p className="font-light text-[11px]">
                  Reports & Presentations
                </p>
                <p className="font-light text-[11px]">
                  Shareholder Communications
                </p>
              </div>
            </div>
          </div>

          <div className="flex flex-row gap-5">
            <div className="flex flex-col items-center justify-center gap-4">
              <img src={image} className="w-12 h-12" alt="" />
              <p className="text-sm font-light">©2023 Gogibus</p>
            </div>
            <div className="flex flex-col items-center justify-center gap-4">
              <img src={image2} className="w-12 h-12" alt="" />
              <p className="text-sm font-light">Privacy Policy</p>
            </div>
            <div className="flex flex-col items-center justify-center gap-4">
              <img src={image3} className="w-12 h-12" alt="" />
              <p className="text-sm font-light">Terms of Use</p>
            </div>
            <div className="flex flex-col items-center justify-center gap-4">
              <img src={image4} className="w-12 h-12" alt="" />
              <p className="text-sm font-light">Anti-Slavery Policy</p>
            </div>
          </div>
        </div>
      </div>

      <div className="lg:hidden flex flex-col my-[100px] items-center gap-[100px] justify-center">
      <h1 className="text-3xl font-extrabold font-mono leading-normal">
        <span className="text-light">Gogi</span>
        <span className="text-[#15A5E7]">Bus</span>{" "}
      </h1>

        <div className="flex  flex-col  gap-[10px] w-[250px] ">
          {faqData.map((faq, index) => (
            <>
              <FaqItem
                key={index}
                faq={faq}
                isSelected={selectedQuestion === index}
                onSelected={() =>
                  setSelectedQuestion(selectedQuestion === index ? null : index)
                }
              />
              <div className="h-[1px] bg-white w-[250px]  text-black "></div>
            </>
          ))}
        </div>
        <div className="flex flex-col gap-10">
          <div className="flex flex-col items-center justify-center">
            <p className="text-[12px] font-light">Level 2, 10 Bond Street,</p>
            <p className="text-[12px] font-light">Sydney, NSW, 2000</p>
          </div>
          <div className="flex flex-col items-center justify-center">
            <p className="text-[12px] font-light">+61 2 9657 0999</p>
            <p className="text-[12px] font-light">info@gogibus.com.au</p>
          </div>
        </div>
        <div className="flex flex-col gap-10 items-center justify-center">
          <div className="flex flex-row gap-4">
            <FaLinkedinIn size={40} />
          </div>
          <div className="h-[1px] bg-white w-[250px] "></div>
        </div>
        <div className="grid grid-cols-2 text-white sm:grid-cols-4 gap-5">
          <div className="flex flex-col items-center justify-center gap-4">
            <img src={image} className="w-12 h-12" alt="" />
            <p className="text-sm font-light">©2023 Gogibus</p>
          </div>
          <div className="flex flex-col items-center justify-center gap-4">
            <img src={image2} className="w-12 h-12" alt="" />
            <p className="text-sm font-light">Privacy Policy</p>
          </div>
          <div className="flex flex-col items-center justify-center gap-4">
            <img src={image3} className="w-12 h-12" alt="" />
            <p className="text-sm font-light">Terms of Use</p>
          </div>
          <div className="flex flex-col items-center justify-center gap-4">
            <img src={image4} className="w-12 h-12" alt="" />
            <p className="text-sm font-light">Anti-Slavery Policy</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
